<script lang="ts" setup>
import { useNavButton } from './composables/useNavButton'

const { locale } = useI18n()
const lang = computed(() => locale.value)
useNavButton()
const route = useRoute()
const customLayoutShowFooter = computed(() => route.meta.layoutProps?.customLayoutShowFooter ?? false)
const customLayoutShowRegularNavigation = computed(() => route.meta.layoutProps?.customLayoutShowRegularNavigation ?? false)
const customLayoutShowSimpleNavigation = computed(() => route.meta.layoutProps?.customLayoutShowSimpleNavigation ?? false)
</script>

<template>
  <Html :lang="lang">
    <Body>
      <UiNavigation
        v-if="customLayoutShowRegularNavigation"
        :sticking="false"
      />
      <nav
        v-if="customLayoutShowSimpleNavigation"
        class="simple-navigation"
      >
        <div class="simple-navigation__content">
          <img
            src="/logo.svg"
            class="simple-navigation__logo"
            alt="Benefit Systems Logo"
          >
        </div>
      </nav>
  
      <main class="main">
        <slot />
      </main>

      <UiFooter v-if="customLayoutShowFooter"/>
    </Body>
  </Html>
</template>

<style lang="scss" scoped>

.simple-navigation {
  position: absolute;
  top:0;
  z-index: 99;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: transparent;

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 156rem;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2.4rem;
    padding-left: 2.4rem;
  }

  &__logo {
    width: 9.6rem;
    height: auto;

    @include atM {
      width: 13.2rem;
    }
  }
}
</style>
